import {Component, Input} from '@angular/core';

@Component({
  selector: 'si-appo-arrival-turn-item',
  templateUrl: './appo-arrival-turn-item.component.html',
  styleUrls: ['./appo-arrival-turn-item.component.scss']
})
export class AppoArrivalTurnItemComponent {
  @Input() ticketSequence: string;
  @Input() locationName: string;
  @Input() actions: string[];
}
